import React from 'react';
import {
  StyledDialog,
  Backdrop,
  Content,
  StyledClose as Close,
} from '@common/components/Dialog/Dialog.styles';
import { Heading4 as Heading } from '@common/components/Typography';
import { Container, HeadingContainer, Panel, StyledToolbar, StyledMarkdown } from './Dialog.styles';

type Props = {
  heading?: string;
  body: string;
  onDismiss: () => void;
};

export function Dialog({ heading, body, onDismiss }: Props) {
  return (
    <StyledDialog open={true} onClose={onDismiss}>
      <Backdrop aria-hidden="true" />

      <Content>
        <Panel>
          <StyledToolbar>
            <Close onClick={onDismiss} />
          </StyledToolbar>

          <Container>
            {heading && (
              <HeadingContainer>
                <Heading>{heading}</Heading>
              </HeadingContainer>
            )}

            <StyledMarkdown text={body} />
          </Container>
        </Panel>
      </Content>
    </StyledDialog>
  );
}
